:host {
  --scroll-offset: 0;

  display: block;
  scroll-margin: var(--scroll-offset);
}
